import { WorkItem, WorkItemStatus } from '../interfaces/worklog.interface'
import { REQUIRES_POINTS_ON } from '../constants/worklog.constants'
import { isValidSplit, needsSplit } from './area-split.util'

/**
 * ¿Mandar la tarea a `to` obliga a clasificarla primero? To Deploy exige esfuerzo, áreas y —si tocó
 * dos o más— cuántos puntos fueron de cada una (F-156). Sin lo primero no cuenta para la velocidad,
 * sin lo segundo no se atribuye a ningún frente, y sin el reparto los frentes no suman el total.
 *
 * Una sola regla para el tablero y el detalle: antes eran dos copias, y una tarea ya puntuada con
 * dos áreas habría pasado sin que nadie le pidiera el reparto.
 */
export function needsClassification(item: Pick<WorkItem, 'points' | 'areas' | 'areaPoints'> | null | undefined, to: WorkItemStatus): boolean {
  if (to !== REQUIRES_POINTS_ON || !item) return false
  if (item.points == null || !item.areas?.length) return true
  return needsSplit(item.areas) && !isValidSplit(item.points, item.areas, item.areaPoints)
}
